import { Container, Grid } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { DELETE_BANK, GET_ALL_BANKS } from 'src/apiService/apiDeclaration';
import { ICONS } from 'src/assets/library';
import BankDetails from 'src/components/form/BankDetails';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import MenuPopover from 'src/components/menu/menu';
import PageHeader from 'src/components/pageHeader/PageHeader';
import CustomTable from 'src/components/table/table';
import TabTitle from 'src/components/tabTitle/tabTitle';
import { showErrorTost, showSuccessTost } from 'src/constants';
import { banksTableColumns } from 'src/constants/columnConfig';
import { useModal } from 'src/hooks/useModal';
import usePagination from 'src/hooks/usePagination';

const Banks = () => {
  const { paginationModel, setPaginationModel, loading, data, refresh } = usePagination(GET_ALL_BANKS);
  const updatedBanksTableColumns = [...banksTableColumns];
  const { setDialogData, handleModalClose } = useModal();
  const onSuccess = () => {
    refresh();
    handleModalClose();
  };
  const onDelete = async (id) => {
    try {
      let resp = await DELETE_BANK(id);
      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      onSuccess();
    }
  };
  updatedBanksTableColumns.push({
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: ({ row }) => {
      return (
        <MenuPopover
          menuArray={[
            {
              icon: ICONS.edit,
              name: t('common.edit'),
              action: () => {
                setDialogData({
                  showModal: true,
                  title: t('common.edit') + ' ' + t('bankDetails.bankName'),
                  child: <BankDetails onSuccess={() => onSuccess()} data={row} />,
                });
              },
            },
            {
              icon: ICONS.delete,
              name: t('common.delete'),
              action: () => {
                setDialogData({
                  showModal: true,
                  description: t('common.delConfirmationBank'),
                  onConfirm: () => onDelete(row._id),
                });
              },
            },
          ]}
        />
      );
    },
  });
  return (
    <Container>
      <Grid container spacing={2}>
        <TabTitle title={'Banks'} />
        <Grid item xs={12}>
          <Grid
            container
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid item xs={8}>
              <PageHeader pageTitle={t('navMenu.banks')} />
            </Grid>
            <Grid item xs={4} sm={2}>
              <LoaderButton
                buttonText={t('bankDetails.addBank')}
                onClick={() =>
                  setDialogData({
                    showModal: true,
                    title: t('bankDetails.addBank'),
                    child: <BankDetails onSuccess={() => onSuccess()} />,
                  })
                }
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <CustomTable
            loading={loading}
            isServerSidePagination
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            columns={updatedBanksTableColumns}
            rows={data?.rows}
            rowCount={data?.rowCount}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Banks;
